import { FileRepository } from '@src/main/shared/domain/file.repository';

export const downloadFileUseCase = async (
  keyFile: string,
  fileName: string,
  repository: FileRepository,
): Promise<void> => {
  await repository.download(keyFile, fileName);
};
